<template>
  <a :href="url">
    <v-card
      rounded="xl"
      flat
      color="white"
      :height="setupUI.height"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
    >
      <v-container fill-height>
        <v-img :src="backgroundImage" :alt="name" contain :height="setupUI.imageHeight"></v-img>

        <v-container fill-height v-if="hover" class="primary box pa-2">
          <div class="pl-3">
            <v-icon color="accent">mdi-chevron-right</v-icon>
            <span class="white--text">View Website</span>
          </div>
        </v-container>
      </v-container>
    </v-card>
  </a>
</template>

<script>
  export default {
    name: "PartnerCard",
    props: {
      url: { type: String, default: '' },
      backgroundImage: { type: String, default: '' },
      name: { type: String, default: '' },
    },
    data: () => ({
      hover: false,
    }),
    computed: {
      setupUI() {
        let breakpoint = this.$vuetify.breakpoint.name;

        if (["xs", "sm"].includes(breakpoint)) {
          return {
            height: "120px",
            imageHeight: "100%"
          };
        }

        /**
         * "md", "lg", "xl"
         */
        return {
          height: "220px",
          imageHeight: "60%"
        };
      },
    },
  }
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.box {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 45px;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}

.box:hover {
  background-color: $accent-blue !important;

  .v-icon  {
    color: white !important;
  }
}
</style>